import React from "react";
import { Images } from "../../../../Assets/0a-exporter";

export default function MobileNotification({ setContentInside }) {
  return (
    <div className="mobile-notification-main">
      <header onClick={() => setContentInside("home")} className="mnm-header">
        <img src="https://img.icons8.com/fluency-systems-regular/48/000000/less-than.png" />{" "}
        <h6>Notifications</h6>
      </header>
      <div className="mnm-body">
        {[1, 2, 3, 4, 5].map((obj) => (
          <div className="mnm-row">
            <img src={Images.suitcaseLogo} />
            <div>
              <p>Your application to Gera Institute is under review</p>
            </div>
            <span>1h ago</span>
          </div>
        ))}
      </div>
    </div>
  );
}
